export enum PollType {
    BOARD = 0,
    TSP = 1,
    PARTNER = 2,
    AP = 3,
    GENERIC = 4
}